export default "__VITE_ASSET__Ccqn90D4__"